import { Component, OnInit, ViewChild } from '@angular/core';
import {  VVerificationServiceServiceProxy, VVerificationDto, VVerificationCreateDto, ExportRequestDto } from '@shared/service-proxies/service-proxies';
import { AlertController, LoadingController } from '@ionic/angular';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { Router, NavigationExtras } from '@angular/router';
import { ExportService } from '@shared/export/export.service';
import * as moment from 'moment';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { Title } from '@angular/platform-browser';
import { Page } from 'src/model/page';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { retryWhen } from 'rxjs/operators';


@Component({
  selector: 'app-verifications',
  templateUrl: './verifications.page.html',
  styleUrls: ['./verifications.page.scss'],
})
export class VerificationsPage implements OnInit {

  rows: VVerificationDto[];
  page = new Page();
  ColumnMode = ColumnMode;
  sortTerm: string = 'farmName';
  sortDirection: string = 'ASC';
  countyId: number;
  isLoaded: boolean = false;
  constructor(
    private verificationSvc: VVerificationServiceServiceProxy,
    private alertController: AlertController,
    storageService: AppStorageService,
    private router: Router,
    private permissionChecker: PermissionCheckerService,
    private exportService: ExportService,
    private titleService: Title,
    private loadingCtrl: LoadingController
  ) {
    this.titleService.setTitle('OACI - Assessments List');
    this.page.pageNumber = 0;
    this.page.size = 10;
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.getVerifications();
        this.isLoaded = true;
      }
    });
  }

  ionViewWillEnter() {
    if (this.isLoaded) {
      this.getVerifications();
    }
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  getVerifications() {
    this.verificationSvc.getAll(
      this.countyId,
      this.sortTerm + ' ' + this.sortDirection,
      this.page.pageNumber * this.page.size,
      this.page.size
    ).subscribe(response => {
      this.rows = response.items;
      this.page.totalElements = response.totalCount;
      this.page.totalPages = Math.ceil(response.totalCount / this.page.size);
    });
  }

  newVerification() {
    const request = new VVerificationCreateDto();
    this.verificationSvc.create(request).subscribe(verification => {
      this.goToVerification(verification.id);
    });
  }

  goToVerification(id) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        verificationId: id
      }
    };
    this.router.navigate(['/main/verification'], navigationExtras);
  }

  async deleteVerification(id) {
    const alert = await this.alertController.create({
      header: 'Delete',
      message: 'Are you sure you want to delete this Assessment?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Confirm Okay');
          }
        },
        {
          text: 'Delete',
          cssClass: 'danger',
          handler: (blah) => {
            this.verificationSvc.delete(id).subscribe(() => {
              this.rows = this.rows.filter(x => x.id != id);
            });
          }
        }
      ]
    });

    await alert.present();
  }

  isAdmin() {
    return this.permissionChecker.isGranted("Role.Admin");
  }

  async export() {
    
    const loading = await this.loadingCtrl.create({
      message: 'Please wait while we generate your report...',
    });
    await loading.present();
    
    this.verificationSvc.getAllWithQuestionAnswers(
      this.countyId,
      this.sortTerm + ' ' + this.sortDirection,
      0,
      2147483647
    ).subscribe(response => {
      const request = new ExportRequestDto();
      request.entity = 'Assessments';
      request.columnNames = [
        'Farm Name',
        'County',
        'Latitude',
        'Longitude',
        'Status',
        'Creator',
        'Created On',
        'Last Modifier',
        'Last Modified On'
      ];
      response.questions.forEach(q => request.columnNames.push(q));
      request.data = [];
      response.vVerificationWithQuestionAnswersDtos.forEach(vVerificationWithQuestionAnswersDto => {
        let row = [
          vVerificationWithQuestionAnswersDto.farmName,
          vVerificationWithQuestionAnswersDto.countyName,
          vVerificationWithQuestionAnswersDto.latitude ? vVerificationWithQuestionAnswersDto.latitude.toString() : null,
          vVerificationWithQuestionAnswersDto.longitude ? vVerificationWithQuestionAnswersDto.longitude.toString() : null,
          vVerificationWithQuestionAnswersDto.statusId == 0 ? 'New' : vVerificationWithQuestionAnswersDto.statusId == 1 ? 'In Progress' : 'Completed',
          vVerificationWithQuestionAnswersDto.creatorUserName,
          moment(vVerificationWithQuestionAnswersDto.creationTime).format('MM/DD/YYYY'),
          vVerificationWithQuestionAnswersDto.lastModifierUserName,
          moment(vVerificationWithQuestionAnswersDto.lastModificationTime).format('MM/DD/YYYY')
        ];
        vVerificationWithQuestionAnswersDto.questionAnswers.forEach(qA => row.push(qA));
        request.data.push(row);
      });
      this.exportService.export(request, loading);
    });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.getVerifications();
  }

  onSort(event) {
    this.sortTerm = event.column.prop;
    this.sortDirection = event.newValue.toUpperCase();
    this.getVerifications();
  }

}
